
import { Component, Vue, Watch } from "vue-property-decorator";
import { YtoTable } from "@/views/components";
import TableHeaderConfig from "./config";
import TableHeader from "./TableHeader.vue";
import { PaperSizeEnum, PaperSizeOptions } from "@/common/enum/paper-size";
import { PrintUtils } from '@/common/print-utils';
// import { Message } from "node_modules/element-ui/types";

@Component({
  name: "Reprint",
  computed: {
    PaperSizeOptions() {
      return PaperSizeOptions
    }
  },
  components: {
    YtoTable,
    TableHeader,
  },
})
export default class extends Vue {
  @Watch("inputModel", { deep: true })
  onChildChanged(val: string) {
    this.ScanCodeChangeFunc(val);
  }
  mounted() {
    try {
      this.hasPaperSizeOption = PrintUtils.hasPaperSizeOption();
      this.input_PaperSize = this.hasPaperSizeOption ? PrintUtils.getDefaultPaperSize() : "";
      obj_PackageReprint.regist_errormessage(this.showerrormessage);
      obj_PackageReprint.regist_reprintList(this.showreprintlist);
      obj_PackageReprint.regist_disableprint(this.disableprintcallback);
    } catch (error) {
      console.log("包签补打界面注册对象出现异常:" + error);
    }
    var el = document.getElementById("input1");
    this.selectElementContents(el);
  }
  public selectElementContents(el) {
    //失去焦点，获取焦点
    el.blur();
    el.focus();
  }

  //测试方法，需要在C#中打断点后才能调试。
  // public aaaaa()
  // {
  //   this.labelData = {
  //     waybillNo :"1234567890",
  //     printSequence :"",
  //     printTime :"",
  //     expireDatetime :"2022-5-11 23:53:43",
  //     createOrgCode :"222222",
  //     createOrgName :"中心名称",
  //     packageName :"包名成-319",
  //     takeApartOrgCode :"111111",
  //     takeApartOrgName :"拆包地name",
  //     packageType :"",
  //     productType :"VIP航空",
  //     createUserCode :"",
  //     createUserName :"",
  //     opOrgType :"",
  //     uploadTime :"",
  //     channel :"",
  //     ext1 :"包名称",
  //     ext2 :"分拣标识码",
  //     ext3 :"",
  //     ext4 :"",
  //   };
  //   this.SubmitPackageDataFunc();
  // }
  public showList = [];
  public showPrintedList = [];
  private form = null;
  private inputModel = { input_ScanCode: "" };
  private input_PaperSize: string = "";
  private hasPaperSizeOption: boolean = false;
  public currentrow = null;
  private config = TableHeaderConfig;
  public callbackmodel = {};

  //C#把打印按钮置灰
  public disableprintcallback() {
    this.printState.submitPrintDisable = true;
  }
  //实时更新查询按钮状态
  private ScanCodeChangeFunc(val) {
    if (val.input_ScanCode.length > 0) {
      this.printState.searchDisable = false;
    } else {
      this.printState.searchDisable = true;
    }
  }
  //根据输入查询包签数据
  private SearchPackageLabelFunc() {
    try {
      var codelist = [];
      var code = this.inputModel.input_ScanCode.toUpperCase();
      this.inputModel.input_ScanCode =
        this.inputModel.input_ScanCode.toUpperCase();
      console.log(code);
      if (code.split("\n").length > 1) {
        code.split("\n").forEach((element) => {
          if (element.length > 0) {
            codelist.push(element);
            if (codelist.length > 1) {
              this.printState.searchDisable = false;
            } else {
              this.printState.searchDisable = true;
            }
          }
        });
      } else {
        codelist.push(code);
      }
      console.log(codelist);
      obj_PackageReprint.searchPrintData(
        codelist,
        this.searchPrintDataCallback
      );
    } catch (error) {}
  }
  //查询方法回调
  public searchPrintDataCallback(response) {
    try {
      if (response.respcode == "000") {
        this.showList = [];
        this.showList.push(response.data);

        this.labelData = response.data;
        this.printState.submitPrintDisable = false;
      } else {
        console.log(response);
        // this.$message.error(response.respMessage);
        this.alertmessage("包签补打", response.respMessage);
      }
    } catch (error) {
      console.log(error);
    }
  }

  public alertmessage(title, message) {
    this.$alert(message, title, {
      confirmButtonText: "确定"
    });
  }
  //重置界面
  private ResetDataFunc() {
    this.inputModel.input_ScanCode = "";
    // this.printState.submitPrintDisable = true;
    // this.showList = [];
    // this.showPrintedList = [];
  }
  //提交打印给C#
  private SubmitPackageDataFunc() {
    console.log("提交打印");

    this.labelData.paperSize = this.input_PaperSize;
    obj_PackageReprint.submitPrintData(
      this.labelData,
      this.submitPrintDataCallback
    );
    PrintUtils.savePaperSize(this.input_PaperSize);
  }
  private tableHeaderConfig = TableHeaderConfig;
  private printState = {
    searchDisable: true,
    resetDisable: false,
    submitPrintDisable: true,
  };
  public labelData;

  //C#展示错误数据
  public showerrormessage(error) {
    // this.$message.error("包签补打:" + error);
    this.alertmessage("包签补打", error);
  }
  //C#展示打印历史
  public showreprintlist(printlist) {
    printlist.forEach((element) => {
      if (element.packageType == "QY") {
        element.packageType = "汽运";
      } else if (element.packageType == "HK") {
        element.packageType = "航空";
      }
    });

    this.showPrintedList = printlist;
    this.showList = [];
  }
  //提交打印
  public submitPrintDataCallback(response) {
    try {
      // this.$message.error(response);
      this.alertmessage("包签补打", response);
    } catch (error) {
      console.log(error);
    }
  }
  //表格控件选中的某一行
  private currentRowChanged(element) {
    console.log(element);
    this.currentrow = element;
  }
  //C#回调方法
  //更新数据列表的数据
  public datahistorycallback(data) {
    console.log(data);
    console.log("列表回传方法");
    this.showPrintedList = data;
  }
}
